import { Button, Grid, Stack, Typography } from '@mui/material'
import { useAppDispatch } from 'app/hooks'
import { UIAction } from 'app/slices/UI'
import AccountTable from 'components/Account/Table'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function AccountPage() {
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(
      UIAction.setBreadcrumbs([
        {
          text: 'ホーム',
          url: '/',
        },
        {
          text: 'アカウント管理',
          url: '/account',
        },
      ])
    )
  }, [dispatch])
  return (
    <Grid container spacing={1} mt={2}>
      <Grid item xs={12}>
        <Typography
          variant="h5"
          component="h2"
          fontWeight="bold"
          sx={{ borderBottom: 2 }}
        >
          アカウント管理
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Stack
          direction={{
            xs: 'column',
            md: 'row',
          }}
          spacing={1}
          alignItems={{
            xs: 'flex-start',
            md: 'center',
          }}
          justifyContent="space-between"
          my={2}
        >
          <Typography variant="h6" component="h3" fontWeight="bold" ml={1}>
            アカウント一覧
          </Typography>
          <Link to="/account/register">
            <Button
              color="secondary"
              variant="contained"
              sx={{
                px: 6,
                borderColor: '#aaa',
                borderRadius: 2,
              }}
            >
              新規登録
            </Button>
          </Link>
        </Stack>
        <AccountTable />
      </Grid>
    </Grid>
  )
}
